const actions = {
  SET_STATE: 'aiphotobooth/SET_STATE',
  UPLOAD_IMAGE: 'aiphotobooth/UPLOAD_IMAGE',
  UPLOAD_PHOTOBOOTH_IMAGE: 'aiphotobooth/UPLOAD_PHOTOBOOTH_IMAGE'
}

export default actions
